export const darkTheme_bg_color = "var(--bg-primary)";
export const darkTheme_New_bg_color = "var(--bg-secondary)";
export const button_bg_color_for_New_Project = '#f6be6b';
export const hovered_chat_bg_color = "var(--bg-elevated)";
export const selected_chat_bg_color = "var(--bg-surface)";
export const prompt_Input_bg_color_for_darkmode = "var(--bg-surface)";
export const uploadFiles_button_default_bg_color = "#FFFFFF";
export const uploadFiles_button_hovered_bg_color = "#CDCFDF";
export const uploadFiles_button_clicked_bg_color = "#B7BAD5";
export const uploadFiles_button_text_color_dm = "var(--text-on-accent)";
export const linkUploader_bg_color = "var(--bg-surface)";
export const linkUploader_Text_color = "var(--text-primary)";
export const oneClickModal_backgroundColor_dm = "var(--bg-surface)";
export const fileUploader_bg_color_inside_onclickModal = "var(--bg-surface)";
export const fileUploader_bg_color_for_dm = "var(--bg-surface)";
export const settingsModal_bg_color_dm = "var(--bg-surface)";
export const selecetedSettings_Nav_bg_dm = "var(--bg-active)";
export const hoveredSettings_Nav_bg_dm = "var(--bg-hover)";
export const selected_SettingsButton_bg_color = "var(--bg-active)";
export const defaultSettings_button_bg_color = "var(--bg-hover)";
export const hoveredSettings_button_bg_color = "var(--bg-active)";
export const ImageSlider_Active_Dod = "var(--icon-default)";
export const ImageSlider_Inactive_Dod_bg = "var(--slider-inactive)";



export const button_bg_color_for_New_Project_dm = '#f6be6b';
export const button_bg_color_for_New_Project_lm = '';
export const hovered_chat_bg_color_dm = "var(--bg-elevated)";
export const hovered_chat_bg_color_lm = "";
export const selected_chat_bg_color_dm = "var(--bg-surface)";
export const selected_chat_bg_color_lm = "";
export const prompt_Input_bg_color_for_dm = "var(--bg-surface)";
export const prompt_Input_bg_color_for_lm = "";
export const landingPage_mainTitle_textColor_dm = '#F6BE6A';
export const landingPage_mainTitle_textColor_lm = '#F6BE6A';


// Chat
export const user_conversation_bg_color = "var(--bg-user-message)";
export const agent_conversation_bg_color = 'var(--bg-ai-message)';
